export const ValorRpaModuleName = {
    VALORPAYTECH_IPG: 'valorpaytech-ipg' as const,
    // Historical signed releases, release floors and stored permission grants retain this identity.
    VALORPAYTECH_WORKFLOWS: 'valorpaytech-workflows' as const,
} as const;

export type ValorRpaModuleName = (typeof ValorRpaModuleName)[keyof typeof ValorRpaModuleName];
